package com.merkost.handpass.api.dto

import com.merkost.handpass.api.dto.admin.PaginationMeta
import kotlinx.serialization.Serializable

@Serializable
data class ApiResponse<T>(
    val data: T? = null,
    val meta: PaginationMeta? = null,
    val error: ApiError? = null
) {
    companion object {
        fun <T> success(data: T, meta: PaginationMeta? = null) =
            ApiResponse(data = data, meta = meta)

        fun error(
            code: String,
            message: String,
            requestId: String? = null,
            timestamp: String? = null,
            details: Map<String, String>? = null
        ) = ApiResponse<Nothing>(
            error = ApiError(code, message, requestId, timestamp, details)
        )
    }
}
